// Mock data for Unite Marketing website

export const blogPosts = [
  {
    id: '1',
    title: 'How MSPs Can Leverage Content Marketing for Growth',
    slug: 'msp-content-marketing-growth',
    excerpt: 'Discover proven content marketing strategies that help managed service providers attract and retain clients in a competitive market.',
    content: 'Full blog content here...',
    author: 'Bronwyn Vrey',
    authorImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
    date: '2024-01-15',
    readTime: '5 min read',
    category: 'MSP Marketing',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop',
    tags: ['Content Marketing', 'MSP', 'Digital Strategy']
  },
  {
    id: '2',
    title: 'The Ultimate Guide to Building a 12-Month Marketing Plan',
    slug: 'building-12-month-marketing-plan',
    excerpt: 'Learn how to create a comprehensive marketing strategy that keeps your business on track and drives consistent growth throughout the year.',
    content: 'Full blog content here...',
    author: 'Bronwyn Vrey',
    authorImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
    date: '2024-01-10',
    readTime: '8 min read',
    category: 'Marketing Strategy',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=500&fit=crop',
    tags: ['Strategy', 'Planning', 'Business Growth']
  },
  {
    id: '3',
    title: 'Why Your Business Needs SEO in 2024',
    slug: 'business-needs-seo-2024',
    excerpt: '97% of users search online to find local businesses. Learn why SEO is no longer optional for business growth.',
    content: 'Full blog content here...',
    author: 'Josh Tristram',
    authorImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop',
    date: '2024-01-05',
    readTime: '6 min read',
    category: 'Digital Marketing',
    image: 'https://images.unsplash.com/photo-1432888622747-4eb9a8f2c293?w=800&h=500&fit=crop',
    tags: ['SEO', 'Digital Marketing', 'Web Traffic']
  },
  {
    id: '4',
    title: 'Social Media Marketing for Tech Companies',
    slug: 'social-media-marketing-tech-companies',
    excerpt: 'Tech companies often struggle with social media. Here are proven strategies to build your brand presence and engage your audience.',
    content: 'Full blog content here...',
    author: 'Bronwyn Vrey',
    authorImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
    date: '2023-12-28',
    readTime: '7 min read',
    category: 'Content Marketing',
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&h=500&fit=crop',
    tags: ['Social Media', 'Tech Marketing', 'Brand Building']
  },
  {
    id: '5',
    title: 'Email Marketing Best Practices for B2B',
    slug: 'email-marketing-b2b-best-practices',
    excerpt: 'Email marketing remains one of the most effective channels for B2B companies. Learn how to craft campaigns that convert.',
    content: 'Full blog content here...',
    author: 'Josh Tristram',
    authorImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop',
    date: '2023-12-20',
    readTime: '5 min read',
    category: 'Email Marketing',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=500&fit=crop',
    tags: ['Email Marketing', 'B2B', 'Conversions']
  },
  {
    id: '6',
    title: 'Marketing on a Budget: Getting Started',
    slug: 'marketing-budget-getting-started',
    excerpt: 'You don\'t need a massive budget to start marketing effectively. Here\'s how small businesses can compete with limited resources.',
    content: 'Full blog content here...',
    author: 'Bronwyn Vrey',
    authorImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
    date: '2023-12-15',
    readTime: '6 min read',
    category: 'Marketing Tips',
    image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&h=500&fit=crop',
    tags: ['Small Business', 'Budget Marketing', 'Getting Started']
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Mark Ternent',
    company: 'GTB Solutions',
    role: 'Director',
    image: 'https://customer-assets.emergentagent.com/job_web-recreator-2/artifacts/3vkzukj3_Mark.jfif',
    content: 'We\'ve been working with Bronny and her team for just over 2 years, as our outsourced marketers. We needed someone to just make this stuff happen - and it has! Social media, monthly ecomms emails to clients, blog articles, events, etc. We HIGHLY RECOMMEND them. Gilly is great to work with and I appreciate having her on my team.',
    rating: 5
  },
  {
    id: 2,
    name: 'Andrew Fergus',
    company: 'Ultra Proactive IT Solutions',
    role: 'Director',
    image: 'https://customer-assets.emergentagent.com/job_web-recreator-2/artifacts/dxmmyo8n_Andrew.jfif',
    content: 'When we needed to outsource our marketing department, we started working with Bronny from MPRE marketing. Bronny and her team are professionals at getting our newsletter collated and out on time, running our social media, writing blogs for us, collecting testimonials, and helping us with marketing projects. We would highly recommend the Unite team.',
    rating: 5
  },
  {
    id: 3,
    name: 'Nancy Koroheke-Yorke',
    company: 'Yorke Stone & Associates CA',
    role: 'Director',
    image: 'https://customer-assets.emergentagent.com/job_web-recreator-2/artifacts/sbr4h3mr_Nancy.jfif',
    content: 'We\'ve worked with the Unite team for just under 2 years. Originally, they came on board to help support with monthly marketing however we quickly realized we needed a strategy. We dug deeper into our business and learned a lot about our client\'s needs. As a result, we were more deliberate in our approach to not only our marketing but also our sales and client management. We highly recommend the Unite team.',
    rating: 5
  },
  {
    id: 4,
    name: 'Shaun Drylie',
    company: 'Carbn (Ex CEO of SBS Bank)',
    role: 'Ex CEO',
    image: 'https://customer-assets.emergentagent.com/job_web-recreator-2/artifacts/7kjunoru_Shaun.jfif',
    content: 'Carbn has worked with Bronnie since mid-2022 and we have been impressed with her ability to facilitate and guide conversations with us to help convert our business strategy into our brand and marketing strategy. Her communication style is always upbeat and collegial. We have enjoyed our time with Unite and believe others will gain good value from their services and expertise.',
    rating: 5
  },
  {
    id: 5,
    name: 'Rob Facer',
    company: 'IT Centre',
    role: 'Director',
    image: 'https://customer-assets.emergentagent.com/job_web-recreator-2/artifacts/rqhk5c7e_Rob%20Facer.jfif',
    content: 'We\'ve worked with Unite marketing for over 2 years. In that time they have efficiently produced our monthly email, managed our social media pages and written articles for our website. We\'ve always found them to deliver on time, and would recommend them as your outsourced marketing team.',
    rating: 5
  },
  {
    id: 6,
    name: 'Trent Mankelow',
    company: 'Optimal Experience (Ex CCO of TradeMe)',
    role: 'Founder',
    image: 'https://customer-assets.emergentagent.com/job_web-recreator-2/artifacts/3uwudkfa_Trent%20Mankelow.jfif',
    content: 'Bronny is a rogue, in the very best sense. She pushed us, and Summer of Tech is better because of her entrepreneurial bent. My favourite memories of her were when she was coming up with marketing campaigns for sponsors - she was inventive, clever and original and our sponsors loved her ideas.',
    rating: 5
  }
];

export const services = [
  {
    id: 1,
    title: 'Monthly Marketing',
    description: 'Consistent, strategic marketing support at a fraction of the cost of hiring full-time staff.',
    icon: 'Calendar',
    link: '/monthly-marketing'
  },
  {
    id: 2,
    title: 'Marketing Strategy',
    description: '12-month marketing plans and strategic workshops to guide your business growth.',
    icon: 'Target',
    link: '/marketing-strategy'
  },
  {
    id: 3,
    title: 'Digital Marketing',
    description: 'SEO, web design, and targeted advertising to reach your audience effectively.',
    icon: 'Globe',
    link: '/digital-marketing'
  },
  {
    id: 4,
    title: 'MSP Marketing',
    description: 'Specialized marketing support for Managed Service Providers and tech companies.',
    icon: 'Server',
    link: '/unite-nation-tech'
  }
];

export const stats = [
  { value: '50+', label: 'Clients Served' },
  { value: '7+', label: 'Years Experience' },
  { value: '98%', label: 'Client Satisfaction' }
];

export const pricingPlans = [
  {
    id: 1,
    name: 'Foundations',
    hours: 8,
    price: 'Custom',
    description: 'For businesses that need to set up their key marketing channels, gain some direction and be consistent.',
    features: [
      'Short Newsletter',
      '2 social media posts per week',
      '8 posts per month total',
      'Basic strategy guidance',
      'Email support'
    ],
    popular: false
  },
  {
    id: 2,
    name: 'Build',
    hours: 10,
    price: 'Custom',
    description: 'Businesses that have some traction with their marketing but need to pull it all together neatly and add some strategic direction.',
    features: [
      'Blog writing',
      'Newsletter creation',
      '3 social media posts per week',
      '12 posts per month total',
      'Strategic planning',
      'Priority support'
    ],
    popular: true
  },
  {
    id: 3,
    name: 'Grow',
    hours: 12,
    price: 'Custom',
    description: 'Businesses that have some consistency, need strategy and some help implementing.',
    features: [
      'Original blog content',
      'Advanced newsletters',
      '3 posts per week on multiple platforms',
      'Content strategy',
      'SEO optimization',
      'Dedicated support',
      'Monthly strategy calls'
    ],
    popular: false
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Bronwyn Vrey',
    role: 'Founder & Marketing Strategist',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    bio: 'With over 10 years in marketing, Bronwyn has worked with major brands including Xero, Microsoft, and TradeMe.'
  },
  {
    id: 2,
    name: 'Josh Tristram',
    role: 'Digital Marketing Specialist',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
    bio: 'Josh specializes in SEO and digital strategy with a background in working with MSPs and tech companies.'
  }
];

export const brands = [
  { name: 'Xero', logo: 'Xero' },
  { name: 'Microsoft', logo: 'Microsoft' },
  { name: 'Dicker Data', logo: 'Dicker Data' },
  { name: 'TradeMe', logo: 'TradeMe' },
  { name: 'Pushpay', logo: 'Pushpay' },
  { name: 'FNZ', logo: 'FNZ' }
];
